module.exports = __webpack_public_path__ + "static/media/404-clouds.3f34c840.jpg";